import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { WebsiteAuditService } from '../website-audit.service';
import { Subscription } from 'rxjs';
import { UX_icons } from '../variables';

@Component({
  selector: 'app-cr',
  templateUrl: './cr.component.html',
  styleUrls: ['../ux/ux.component.css', './cr.component.css'],
})
export class CrComponent implements OnInit, OnDestroy {
  constructor(private websiteAuditService: WebsiteAuditService) {}

  @ViewChild('separator') separator: any;

  private subs: Subscription = new Subscription();

  public scoreCards: any = [];

  public selectedScoreCard: any = {};

  private icons: any = UX_icons;

  public isLoading: boolean = false;

  ngOnInit(): void {
    this.subs.add(
      this.websiteAuditService.getSelectedAuditTask().subscribe((res: any) => {
        this.scoreCards =
          res?.auditRankings?.Conversion?.map((item: any) => {
            item.selected = false;
            item.title = item?.category;
            item.icon = this.icons?.[item?.category] || false;
            item.averageScore = Math.round(item?.averageScore);
            item.optimalScore =
              item?.averageScore < item?.optimalScore
                ? Math.round(item?.optimalScore || 100)
                : Math.max(Math.round(item?.optimalScore || 100), 100);
            return item;
          }) || [];

        this.selectScoreCard(this.scoreCards?.[0]);
      }),
    );

    this.subs.add(
      this.websiteAuditService.getAuditTasksLoading().subscribe((res: any) => {
        this.isLoading = res;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public selectScoreCard(card: any): void {
    if (!card) {
      return;
    }

    this.scoreCards.forEach((scoreCard: any) => {
      scoreCard.selected = false;
    });
    card.selected = true;
    // this.selectedScoreCard = card;
    this.selectedScoreCard.title = card.title;
    this.selectedScoreCard.value = card.value;

    this.selectedScoreCard.notWorkingWell = card?.notWorkingWell;
    this.selectedScoreCard.workingWell = card?.workingWell;

    requestAnimationFrame(() => {
      if (this.separator?.nativeElement) {
        this.separator.nativeElement.style.height = '0px';
        setTimeout(() => {
          this.separator.nativeElement.style.height =
            this.separator.nativeElement.parentElement?.scrollHeight + 'px';
        }, 100);
      }
    });
  }
}
